<template>
  <div>
    <label>
      <GmapAutocomplete
        :value="map_address"
        @input="value = $event.target.value"
        style="width: auto"
        @place_changed="setPlace"
      >
      </GmapAutocomplete>
      <!-- <button @click="usePlace">Add</button>-->
    </label>

    <br />
    <br />
    <GmapMap
      style="width: 100%; height: 300px"
      :zoom="15"
      :center="{ lat: parseFloat(storelat), lng: parseFloat(storelng) }"
    >
      <GmapMarker
        v-for="(marker, index) in markers"
        :key="index"
        :draggable="true"
        :icon="map"
        :position="marker.position"
        @dragend="setPlace"
      />
      <GmapMarker
        v-if="this.place"
        label="★"
        :position="{
          lat: this.place.geometry.location.lat(),
          lng: this.place.geometry.location.lng(),
        }"
      />
    </GmapMap>
  </div>
</template>

<script>
//import {gmapApi} from 'vue2-google-maps'
import { mapGetters } from "vuex";
import map from "../assets/images/map.png";
import * as VueGoogleMaps from "vue2-google-maps";

export default {
  name: "MapComponent",
  data() {
    return {
      map,
      markers: [],
      place: null,
      position: [],
      coordinates: {
        lat: 0,
        lng: 0,
      },
      storelatitude: 0,
      storelongitude: 0,
      map_address: "",
    };
  },
  computed: {
    ...mapGetters(["outletInformation"]),
    google: VueGoogleMaps.gmapApi,
  },
  props: ["storelat", "storelng", "deliverylimit"],
  mounted() {
    this.$nextTick(function () {
      this.markers = [];
      this.markers.push({
        position: {
          lat: parseFloat(this.storelat),
          lng: parseFloat(this.storelng),
        },
      });
      //  console.log("storelat " + this.storelat);
      // console.log("storelng " + this.storelng);
      this.storelatitude = parseFloat(this.storelat);
      this.storelongitude = parseFloat(this.storelng);
    });

    /*  this.$getLocation({})
              .then( coordinates => {
                this.$toast.success("User Location Accessed");
                this.coordinates = coordinates

                this.storelat = this.coordinates.lat
                this.storelng = this.coordinates.lng

                this.markers = []
        this.markers.push({
          position: {
            lat: this.storelat,
            lng: this.storelng,
          }
        })
              })
              .catch( error => {
                  
                  this.$toast.error(error);
              })*/
  },
  description: "Autocomplete Example (#164)",
  methods: {
    setDescription(description) {
      this.description = description;
    },
    setPlace(place) {
      //alert(JSON.stringify(place))

      //  alert(place.latLng.lat())

      //  alert(place.latLng.lng())

      // let lat = place.latLng.lat()
      // let lng = place.latLng.lng()

      let latitude = 0;
      let longitude = 0;
      this.place = place;

      if (place.latLng) {
        //  alert("if")

        latitude = place.latLng.lat();
        longitude = place.latLng.lng();

        let API_KEY = ""
          API_KEY = "AIzaSyAI8Rw6GubVmklVABUiHqwq1XqCwPxiAVg"//tmbill
        // API_KEY = "AIzaSyCs6VRK3L7Ep87yU8PkoQl_r_MUuWJLC5k";//The Isha foods
        // API_KEY = "AIzaSyDQ0up_kqWSydl6FwypyTLYreEOY7dvu0M" //grillfry
        
        //API_KEY ="mahamangal"//mahamangal_api_key
        //  API_KEY ="AIzaSyA32ZAKMa4F-PXjBkeQICJg-bg-qBLPbHY" //puchkawala

        let url =
          "https://maps.googleapis.com/maps/api/geocode/json?latlng=" +
          latitude +
          "," +
          longitude +
          "&key=" +
          API_KEY;

        let currentObj = this;

        currentObj.axios
          .get(url)
          .then(function (response) {
            // alert(JSON.stringify(response))

            currentObj.map_address = response.data.results[0].formatted_address;

            // alert("map_address "+response.data.results[0].formatted_address)
            localStorage.setItem(
              "del_address",
              response.data.results[0].formatted_address
            );
            // alert(currentObj.map_address)
          })
          .catch((error) => {
            console.log(error);
          });

        this.markers = [];
        this.markers.push({
          position: {
            lat: latitude,
            lng: longitude,
          },
        });

        this.storelat = latitude;
        this.storelng = longitude;

        /* alert("storelatitude "+this.storelatitude)
      alert("storelongitude "+this.storelongitude)
      alert("deliverylimit "+this.deliverylimit)*/

        localStorage.setItem("userlat", this.storelat);
        localStorage.setItem("userlng", this.storelng);
        localStorage.setItem("storelat", this.storelatitude);
        localStorage.setItem("storelng", this.storelongitude);
        localStorage.setItem("deliverylimit", this.deliverylimit);

        this.place = null;
      } else {
        // alert("else")

        //   alert("latitude "+this.place.geometry.location.lat())
        // alert("latitude "+this.place.geometry.location.lng())
        latitude = this.place.geometry.location.lat();
        longitude = this.place.geometry.location.lng();

        this.markers = [];
        this.markers.push({
          position: {
            lat: latitude,
            lng: longitude,
          },
        });

        this.storelat = latitude;
        this.storelng = longitude;

        //  alert("map_address "+this.place.formatted_address)

        localStorage.setItem("userlat", this.storelat);
        localStorage.setItem("userlng", this.storelng);
        localStorage.setItem("storelat", this.storelatitude);
        localStorage.setItem("storelng", this.storelongitude);
        localStorage.setItem("deliverylimit", this.deliverylimit);
        localStorage.setItem("del_address", this.place.formatted_address);
        this.map_address = this.place.formatted_address;
        this.place = null;
      }

      let storeAddress;
      this.outletInformation.find((outlet) => {
        storeAddress = outlet.address;
      });
      let currentObj = this;

      let useraddress = localStorage.getItem("del_address");

      //  alert("useraddress "+useraddress)
      const service = new currentObj.google.maps.DistanceMatrixService(); //new VueGooglemaps.maps.DistanceMatrixService()

      const origin1 = {
        lat: parseFloat(currentObj.storelatitude),
        lng: parseFloat(currentObj.storelongitude),
      };
      const origin2 = storeAddress;
      const destinationA = useraddress;
      const destinationB = {
        lat: parseFloat(currentObj.storelat),
        lng: parseFloat(currentObj.storelng),
      };
      const request = {
        origins: [origin1, origin2],
        destinations: [destinationA, destinationB],
        travelMode: currentObj.google.maps.TravelMode.DRIVING,
        unitSystem: currentObj.google.maps.UnitSystem.METRIC,
        avoidHighways: false,
        avoidTolls: false,
      };

      //var km = 1613841.93424 / 1000;
      //alert(km.toFixed(1) + " km"); // 1613.8 km

      service.getDistanceMatrix(request).then((response) => {
        // put response
        //  alert((response.rows[0].elements[0].distance.value / 1000).toFixed(2))
        // alert(JSON.stringify(response.rows[0].elements[0].distance.value));
        //  alert(JSON.stringify(response));
        let finaldistance = (
          response.rows[0].elements[0].distance.value / 1000
        ).toFixed(2);
        // alert("finaldistance ", finaldistance);
        localStorage.setItem("deliverylocation", finaldistance);

        this.$store.dispatch("saveDistance", {
          deliverydistance: finaldistance,
        });
      });
    },
  },
};
</script>